/**
 * RuntimeConfig est la projection UI de la config runtime exposée par le
 * control-plane via GET /api/v1/runtime-config.
 *
 * Permet à l'UI de connaître l'URL publique du data-plane — utile pour
 * produire le snippet `export ANTHROPIC_BASE_URL=...` dans la
 * PassthroughConfigCard. En SaaS / self-hosted prod, le control-plane et
 * le data-plane sont derrière le même hostname, dataPlaneUrl est vide et
 * l'UI utilise window.location.origin. En dev local hybride, les ports
 * sont distincts (control-plane :8081, data-plane :8080) et l'admin
 * renseigne runtime.data_plane_url dans la config YAML.
 */
export interface RuntimeConfig {
    readonly dataPlaneUrl: string
}

export const DEFAULT_RUNTIME_CONFIG: RuntimeConfig = {
    dataPlaneUrl: '',
}
